/**
 * workflow-core
 *
 * Copyright (c) Ballerine
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
import { Type } from '@sinclair/typebox';
import { CollectionFlowStepStatesEnum } from '../enums/collection-flow-step-state-enum.js';

var InputCollectionFlowStepSchema = Type.Object({
  stateName: Type.String(),
  state: Type.Optional(Type.Enum(CollectionFlowStepStatesEnum))
});
var CollectionFlowConfigSchema = Type.Object({
  apiUrl: Type.String(),
  steps: Type.Array(InputCollectionFlowStepSchema),
  additionalInformation: Type.Optional(Type.Object({
    customerCompany: Type.Optional(Type.String())
  }, {
    additionalProperties: true
  }))
});

export { CollectionFlowConfigSchema };
//# sourceMappingURL=config-schema.js.map
